/**
 * Interface for board and edge filter parameter type descriptors. These affect the behavior of the parameter card appearance on the Configurator.
 */
interface IFiltersTypeDescriptor {
    duplungable?: boolean
    worktop?: boolean
    edgebandable?: boolean
    oriented?: boolean
    thickness?: { min: number; max: number };
    core?: string[];
}

export default IFiltersTypeDescriptor;
